import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { selectCurrentUser, logoutUser } from '@/features/auth/authSlice';
import { useAppDispatch, useAppSelector } from '@/store/hooks';

function initialsFor(email?: string): string {
  if (!email) {
    return '--';
  }
  const handle = email.split('@')[0] ?? email;
  const parts = handle.split(/[._-]+/).filter(Boolean);
  const initials = parts
    .slice(0, 2)
    .map((part) => part.charAt(0))
    .join('');
  return (initials || handle.slice(0, 2)).toUpperCase();
}

/**
 * Avatar menu (design §6): the session email as static header text plus sign
 * out. Signing out clears the `cluster_workspace_*` tokens and the auth slice;
 * `ProtectedRoute` then routes to `/login`.
 */
export function UserMenu() {
  const dispatch = useAppDispatch();
  const user = useAppSelector(selectCurrentUser);
  const email = user?.email ?? '';
  const label = email || 'Signed in';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="h-9 gap-2 px-2" aria-label="Account menu">
          <Avatar className="h-8 w-8">
            <AvatarFallback className="text-xs">{initialsFor(email)}</AvatarFallback>
          </Avatar>
          <span className="hidden max-w-[16rem] truncate text-sm md:inline">{label}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel className="truncate font-normal">{label}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={() => void dispatch(logoutUser())}>Sign out</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
